import { render, staticRenderFns } from "./ComplieRightMenuIcon.vue?vue&type=template&id=15ddcf28&scoped=true"
import script from "./ComplieRightMenuIcon.vue?vue&type=script&lang=js"
export * from "./ComplieRightMenuIcon.vue?vue&type=script&lang=js"
import style0 from "./ComplieRightMenuIcon.vue?vue&type=style&index=0&id=15ddcf28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ddcf28",
  null
  
)

export default component.exports